import { render, staticRenderFns } from "./ProviderContactInfo.vue?vue&type=template&id=a087d3d4"
import script from "./ProviderContactInfo.vue?vue&type=script&lang=js"
export * from "./ProviderContactInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports